import { render, staticRenderFns } from "./accounting-journals.vue?vue&type=template&id=12899638&scoped=true&"
import script from "./accounting-journals.ts?vue&type=script&lang=ts&"
export * from "./accounting-journals.ts?vue&type=script&lang=ts&"
import style0 from "./accounting-journals.scss?vue&type=style&index=0&id=12899638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12899638",
  null
  
)

export default component.exports